var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.66667H12.1875V4.7619C12.1875 2.13333 10.0875 0 7.5 0C4.9125 0 2.8125 2.13333 2.8125 4.7619V6.66667H1.875C0.84375 6.66667 0 7.52381 0 8.57143V18.0952C0 19.1429 0.84375 20 1.875 20H13.125C14.1562 20 15 19.1429 15 18.0952V8.57143C15 7.52381 14.1562 6.66667 13.125 6.66667ZM7.5 15.2381C6.46875 15.2381 5.625 14.381 5.625 13.3333C5.625 12.2857 6.46875 11.4286 7.5 11.4286C8.53125 11.4286 9.375 12.2857 9.375 13.3333C9.375 14.381 8.53125 15.2381 7.5 15.2381ZM10.4062 6.66667H4.59375V4.7619C4.59375 3.13333 5.89687 1.80952 7.5 1.80952C9.10312 1.80952 10.4062 3.13333 10.4062 4.7619V6.66667Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.cea8f16db75c0c76c49857bb3cbad49e.svg";
export { ForwardRef as ReactComponent };